import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css';
import 'swiper/css/autoplay';


// Importa le immagini
import image1 from "../assets/images/monitor/image01.png";
import image2 from "../assets/images/monitor/image02.png";


import avatar1 from "../assets/images/avatar01.png";
import avatar2 from "../assets/images/avatar02.png";
import avatar3 from "../assets/images/avatar03.png";
import avatar4 from "../assets/images/avatar04.png";
import avatar5 from "../assets/images/avatar05.png";
import avatar6 from "../assets/images/avatar06.png";
import avatar7 from "../assets/images/avatar07.png";
import avatar8 from "../assets/images/avatar08.png";
const avatarMap = {
    avatar01: avatar1,
    avatar02: avatar2,
    avatar03: avatar3,
    avatar04: avatar4,
    avatar05: avatar5,
    avatar06: avatar6,
    avatar07: avatar7,
    avatar08: avatar8,
};


const MonitorView = () => {
    const [gameId, setGameId] = useState(null);
    const [monitorState, setMonitorState] = useState('anamnesi');
    const [classifica, setClassifica] = useState([]);
    const navigate = useNavigate();

    const backgroundColors = [
        'bg-azzurro', 'bg-viola', 'bg-acqua',
        'bg-acqua', 'bg-orange', 'bg-azzurro',
        'bg-orange', 'bg-verdino', 'bg-viola'
    ];

    // Polling per ottenere il gameId attivo
    useEffect(() => {
        const fetchGameId = () => {
            axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-current-game`)
                .then(response => setGameId(response.data.gameId))
                .catch(error => console.error("Errore nel recupero del gameId:", error));
        };

        // Esegui il polling ogni 5 secondi
        const intervalId = setInterval(fetchGameId, 5000);
        return () => clearInterval(intervalId);
    }, []);

    // Recupera la classifica
    useEffect(() => {
        const fetchClassifica = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classifica-generale`);
                setClassifica(response.data);
            } catch (error) {
                console.error("Errore nel recupero della classifica:", error);
            }
        };

        fetchClassifica();
    }, []);

    //console.log(gameId);
    // Polling dello stato del monitor per il gameId attivo
    useEffect(() => {

        if (gameId) {

            const fetchMonitorState = () => {
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-monitor-state`, {
                    params: { gameId }
                })
                    .then(response => {
                        const newMonitorState = response.data.monitor;
                        setMonitorState(newMonitorState); // Imposta l'immagine o lo stato per altri valori

                        // Naviga o aggiorna lo stato in base al valore di monitor
                        if (newMonitorState === 'anamnesi') {
                            navigate('/monitor-cc');  // Naviga alla pagina della domanda 1
                        }  else {
                            setMonitorState(newMonitorState); // Imposta l'immagine o lo stato per altri valori
                        }
                    })
                    .catch(error => console.error("Errore nel recupero dello stato del monitor:", error));
            };


            const intervalId = setInterval(fetchMonitorState, 5000);
            return () => clearInterval(intervalId);
        }
    }, [gameId, navigate]);



    return (
        <div className="fullscreen-container">

            <Swiper
                modules={[Autoplay]}
                effect="fade"
                autoplay={{
                    delay: 15000, // Cambia ogni 15 secondi
                    disableOnInteraction: false,
                }}
                loop={true}
                className="mySwiper"
            >
                 Prima immagine
              <SwiperSlide>
                    <img src={image1} alt="Immagine 1" />
                </SwiperSlide>

                 Seconda immagine
               <SwiperSlide>
                    <img src={image2} alt="Immagine 2" />
                </SwiperSlide>

                {/* Terza view: Classifica Generale */}
                <SwiperSlide>
                    <div
                        className="m_classifica flex flex-col w-full h-full  items-center justify-center  bg-fixed overflow-hidden " style={{border: '0px solid red'}}>
                        <div className="classifica-grid grid grid-cols-3 gap-10 px-10 mt" style={{border: '0px solid red'}}>

                                {classifica.map((giocatore, index) => (
                                    <div key={index} className=" flex flex-col items-center p-4 ">
                                        <img src={avatarMap[giocatore.savatar]} alt="Avatar"
                                             className="w-[250px] h-auto rounded-full mx-auto mb-4"/>
                                        {/*<div
                                            className={`${backgroundColors[index % backgroundColors.length]} rounded-md items-center justify-center`}>*/}
                                        <div className={`w-full text-center ${backgroundColors[index % backgroundColors.length]} rounded-lg p-2`}>
                                            <p className={`text-[54px] font-bold  text-white ${backgroundColors[index % backgroundColors.length]}`}>{giocatore.snickname}</p>
                                            <p className={`text-[54px] font-bold  text-white ${backgroundColors[index % backgroundColors.length]}`}>{giocatore.npunti}</p>
                                        </div>


                                        </div>

                                        ))}
                                    </div>


                                    </div>
                </SwiperSlide>


            </Swiper>
        </div>
);
};

export default MonitorView;
